import Button from '../Button'
import messageResource from '../../messageResource'
import TemplateView from '../../TemplateView'
import {getInsideWindowHeight, getInsideWindowWidth, px} from '../../atBrowserUtils'
import {Moire} from '../Moire'

export default class ConfirmationDialog extends TemplateView {
    constructor({
        contentComponent = null,
        additionalClass = '',
        onConfirm = () => {},
        onCancel = () => {},
        onShow = () => {},
        onHide = () => {},
    } = {}) {
        super(null)

        this.params = {
            contentComponent,
            additionalClass,
        }

        this.callbacks = {
            onConfirm,
            onCancel,
            onShow,
            onHide,
        }
    }


    templateHtml() {
        return '<div class="components_confirmationDialog <%=additionalClass%>">' +
               '    <div class="content"/>' +
               '    <div class="buttons"/>' +
               '</div>'
    }

    templateModel() {
        return {
            additionalClass: this.params.additionalClass,
        }
    }

    afterRender() {
        this.params.contentComponent.init(this.find('.content'))

        this.okButton = new Button({
            label: messageResource.getMessage('common.ok'),
            additionalClass: 'okButton',
            handleEnterKeydown: true,
            onClickCb: () => {
                this.callbacks.onConfirm()
                this.hide()
            }
        }).init(this.find('.buttons'))

        this.cancelButton = new Button({
            label: messageResource.getMessage('common.cancel'),
            additionalClass: 'cancelButton',
            onClickCb: () => {
                this.callbacks.onCancel()
                this.hide()
            }
        }).init(this.find('.buttons'))

        this.moire = Moire.getInstance()
        this.moire.getEl().click((e) => e.stopPropagation())
    }

    hide() {
        super.hide()
        this.moire.hide()
        this.callbacks.onHide()
    }

    show() {
        this.centreAlert()
        this.callbacks.onShow()
        this.moire.show()
        super.show()
    }

    centreAlert() {
        const alert = this.getEl()
        alert.css('left', px(Math.floor((getInsideWindowWidth() - alert.outerWidth()) / 2)))
        alert.css('top', px(Math.floor((getInsideWindowHeight() - alert.outerHeight()) / 2)))
    }
}



// WEBPACK FOOTER //
// ./web/js/components/ConfirmationDialog/ConfirmationDialog.js